export const setNavbar = (isNavbar)=>({
   type:"SET_NAVBAR",
   isNavbar
})


export const setSidebar = (isSidebar)=>({
   type:"SET_SIDEBAR",
   isSidebar
})

export const setTab = (activeTab)=>({
   type:"SET_TAB",
   activeTab
})

export const setToast = (isToast)=>({
   type:"SET_TOAST",
   isToast
})

export const setInfo = (isInfo)=>({
   type:"SET_INFO",
   isInfo
})

export const setPeople = (peoples)=>({
   type:"SET_PEOPLES",
   peoples
})

export const setPopOver = (popover)=>({
   type:"SET_POPOVER",
   popover
})

export const setUser = (user)=>({
   type:"SET_USER",
   user
})

export const setDropDown = (userDropDown)=>({
   type:"ACCOUNT_DROPDOWN",
   userDropDown

})

export const setModal = (isModal)=>({
   type:"SET_MODAL",
   isModal
})

export const setPermission = (isPermission)=>({
   type:"SET_PERMISSION",
   isPermission
})
export const setFeed = (isFeedback)=>({
   type:"SET_FEEDBACK",
   isFeedback

})

export const setFeedImage = (FeedbackImage)=>({
   type:"SET_FEED_IMAGE",
   FeedbackImage
})

export const setMic = (isMicOn)=>({
   type:"SET_MICROPHONE",
   isMicOn
})

export const setCamera = (isCameraOn)=>({
   type:"SET_CAMERA",
   isCameraOn
})

export const setAudio = (audioStream)=>({
   type:"SET_AUDIO",
   audioStream
})

export const setVideo = (videoStream)=>({
   type:"SET_VIDEO",
   videoStream
})

export const setToastMini = (isToastMini)=>({
   type:"SET_TOAST_MINI",
   isToastMini
})